import { render } from "./EditEDI.vue?vue&type=template&id=3ccee276&scoped=true"
import script from "./EditEDI.vue?vue&type=script&lang=js"
export * from "./EditEDI.vue?vue&type=script&lang=js"

import "./EditEDI.vue?vue&type=style&index=0&id=3ccee276&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ccee276"]])

export default __exports__